module.exports = __webpack_public_path__ + "img/231.ff370a49.png";